var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCorporateNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.139 4.559V2.5",
    stroke: "#C9A87A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m5.93 17.936.044-.088c.206-.395.408-.78.618-1.157l.002-.004a6.923 6.923 0 0 0 .852-3.46v-.016l-.002-.017c-.055-.874-.004-1.751.151-2.611a6.888 6.888 0 0 1 1.853-3.486 6.37 6.37 0 0 1 3.32-1.778l2.495.011a6.384 6.384 0 0 1 3.298 1.788 6.9 6.9 0 0 1 1.84 3.473c.155.853.206 1.723.15 2.59v.032a6.91 6.91 0 0 0 .85 3.473l.003.006c.203.362.395.73.592 1.108l.018.034.056.108.004.007c.518.967.895 2.01 1.117 3.095v.003l.028.14a2.108 2.108 0 0 1-.319 1.51 1.89 1.89 0 0 1-1.156.807l-5.063.053h-.002l-3.9.03-6.64-.098a1.915 1.915 0 0 1-1.101-.873 2.121 2.121 0 0 1-.237-1.543l.002-.008.002-.009c.22-1.087.597-2.132 1.115-3.1l.006-.01.005-.01z",
    fill: "#C9A87A",
    fillOpacity: 0.16,
    stroke: "url(#pdq87vj08a)",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.771 24.383c0 1.17-.908 2.117-2.027 2.117-1.12 0-2.028-.948-2.028-2.117",
    stroke: "#C9A87A",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pdq87vj08a",
    x1: 23,
    y1: 19,
    x2: 9.205,
    y2: 5.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9A87A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343E47"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateNotification);
export default __webpack_public_path__ + "static/media/corporateNotification.bb29279a60bcb7c39560a9e56639bd7c.svg";
export { ForwardRef as ReactComponent };